export const getAlarms = (state, systemId) => state[systemId].alarms;

export const getActiveAlarms = (state, systemId) => getAlarms(state, systemId).filter((o) => o.state === 1);

export const getAlarmWarnings = (state, systemId) => getAlarms(state, systemId).filter((o) => o.state === 2);
